import type { IconProps } from '@/ui/Icons/IconProps';

export const GreenCheckmarkIcon = (props: IconProps) => (
  <svg
    className={props.className}
    height={props.height ?? 126}
    width={props.width ?? 126}
    style={props.style}
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.04" filter="url(#filter0_d_3922_78293)">
      <circle cx="63" cy="62" r="59" fill="url(#paint0_linear_3922_78293)" />
      <circle cx="63" cy="62" r="58.5" stroke="#39A150" />
    </g>
    <g opacity="0.08" filter="url(#filter1_d_3922_78293)">
      <circle cx="63" cy="62" r="47" fill="url(#paint1_linear_3922_78293)" />
      <circle cx="63" cy="62" r="46.5" stroke="#39A150" />
    </g>
    <g filter="url(#filter2_ddii_3922_78293)">
      <rect x="34" y="32" width="60" height="60" rx="30" fill="white" />
      <rect x="34" y="32" width="60" height="60" rx="30" fill="#00CB20" fillOpacity="0.06" />
      <rect x="34" y="32" width="60" height="60" rx="30" fill="url(#paint2_linear_3922_78293)" />
    </g>
    <g filter="url(#filter3_i_3922_78293)">
      <path
        d="M78.1668 60.7047V62.008C78.1651 65.063 77.1759 68.0355 75.3467 70.4823C73.5176 72.9291 70.9465 74.719 68.0169 75.5852C65.0874 76.4514 61.9563 76.3474 59.0907 75.2887C56.225 74.23 53.7784 72.2733 52.1157 69.7105C50.453 67.1477 49.6632 64.1161 49.8642 61.0678C50.0652 58.0195 51.2462 55.1178 53.2311 52.7955C55.2159 50.4733 57.8983 48.8548 60.8781 48.1816C63.8579 47.5083 66.9755 47.8163 69.766 49.0597M78.1668 50.6666L64.0002 64.8474L59.7502 60.5974"
        stroke="url(#paint3_linear_3922_78293)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3922_78293"
        x="0.756757"
        y="0.837838"
        width="124.486"
        height="124.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78293" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3922_78293"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3922_78293"
        x="12.7568"
        y="12.8378"
        width="100.486"
        height="100.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78293" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3922_78293"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ddii_3922_78293"
        x="27.5714"
        y="27.7143"
        width="72.8571"
        height="72.8571"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.14286" />
        <feGaussianBlur stdDeviation="3.21429" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78293" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3922_78293"
          result="effect2_dropShadow_3922_78293"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3922_78293"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2.14286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="shape" result="effect3_innerShadow_3922_78293" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.08108" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          mode="normal"
          in2="effect3_innerShadow_3922_78293"
          result="effect4_innerShadow_3922_78293"
        />
      </filter>
      <filter
        id="filter3_i_3922_78293"
        x="48.3335"
        y="46.3333"
        width="31.3333"
        height="31.3333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.41667" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3922_78293" />
      </filter>
      <linearGradient
        id="paint0_linear_3922_78293"
        x1="63"
        y1="3"
        x2="63"
        y2="121"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3922_78293"
        x1="63"
        y1="15"
        x2="63"
        y2="109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3922_78293"
        x1="64"
        y1="19.5"
        x2="64"
        y2="99.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009658" />
        <stop offset="1" stopColor="#00B96D" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3922_78293"
        x1="78.4916"
        y1="43.3642"
        x2="60.4898"
        y2="78.538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
